










































































import XButton from '@/components/atoms/Button/XButton.vue'
import XCheckbox from '@/components/atoms/Checkbox/XCheckbox.vue'
import XForm from '@/components/atoms/Form/XForm.vue'
import XFormLabel from '@/components/atoms/FormLabel/XFormLabel.vue'
import XInput from '@/components/atoms/Input/XInput.vue'
import { Query, ServicePlan, ServicePlanType } from '@/types/generated/graphql'
import BaseStep from './BaseStep.vue'
import SelectPlan from './Partial/SelectPlan.vue'
import SERVICE_PLANS_QUERY from '@/graphql/partner/ffServicePlans.gql'

type Data = {
  agreeToPolicy: boolean
  servicePlans?: ServicePlan[]
}

export default BaseStep.extend<Data, {}, {}, {}>({
  name: 'StepThree',
  components: { XButton, XForm, XInput, XFormLabel, XCheckbox, SelectPlan },
  data() {
    return {
      agreeToPolicy: false,
      ServicePlanType,
    }
  },
  methods: {
    onSubmitStep() {
      this.onSubmit()
    },
    onClickBack() {
      this.onNext('step2')
    },
    hasPlan(type: ServicePlanType) {
      const servicePlan = this.servicePlans?.find((sp) => sp.type === type)
      if (!servicePlan) {
        return false
      }
      return this.input.servicePlanIds?.includes(servicePlan.servicePlanId)
    },
  },
  apollo: {
    servicePlans: {
      query: SERVICE_PLANS_QUERY,
      update(data: Query) {
        return data.ffServicePlans
      },
    },
  },
})
